import React from "react";
import { useSelector } from "react-redux";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import { actionCreators } from "./redux/leadsAddedSagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import ProfilesCreatedMonthToDate from "./smartComponents/profilesCreatedMonthToDate";
import PrevProfilesCreatedMonthToDate from "./smartComponents/prevProfilesCreatedMonthToDate";
import ProfilesCreatedYearToDate from "./smartComponents/profilesCreatedYearToDate";
import PrevProfilesCreatedYearToDate from "./smartComponents/prevProfilesCreatedYearToDate";
import YearOverYear from "./smartComponents/yearOverYear";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { useFetchData } from "../hooks/dataFetchingHooks";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";

const LeadsManagementModule = (props) => {
  useFetchData({
    moduleName: "leadsAdded",
    props,
    fetchData: actionCreators.fetchCurrentUser,
    updateData: actionCreators.updateAllData
  });
  const isLoading = useSelector((state) => state.leadsAdded.isLoading);

  return (
    <SectionToggle
      title="Leads Added"
      learnMore={
        <KBLearnMore
          title="Leads Added"
          description="This report shows the total number of new leads added to your system during the selected date range. These insights help you understand top-of-funnel activity, growth potential, and how well your lead-generation efforts are performing."
          kbUrl={ILEARN_URLS.dashboard.leadsAdded}
        />
      }
      customClass="leadmanagementWidget"
      height={600}
      isLoading={isLoading}
      content={
        <div>
          <div className="section-group">
            <span className="width-50">
              <SectionContainer title="Month To Date">
                <ProfilesCreatedMonthToDate />
              </SectionContainer>
            </span>
            <span className="width-50">
              <SectionContainer title="Month to Date this time Last Year">
                <PrevProfilesCreatedMonthToDate />
              </SectionContainer>
            </span>
          </div>
          <div className="section-group">
            <span className="width-50">
              <SectionContainer title="Year to Date">
                <ProfilesCreatedYearToDate />
              </SectionContainer>
            </span>
            <span className="width-50">
              <SectionContainer title="Year to Date this time Last Year">
                <PrevProfilesCreatedYearToDate />
              </SectionContainer>
            </span>
          </div>
          <div className="section-group" style={{ paddingTop: "50px", width: "100%" }}>
            <span className="top">
              <SectionContainer title="Year over Year Comparison">
                <YearOverYear />
              </SectionContainer>
            </span>
          </div>
        </div>
      }
    />
  );
};

export default LeadsManagementModule;
